import { faBullhorn } from '@fortawesome/free-solid-svg-icons'

export const homeRoutes = {
  name: 'Inicio',
  to: '/dashboard/app',
  exact: true,
  iconsrc: 'Icono Inicio 2.png'
}

export const visitorRoute = {
  to: '/dashboard/visitors',
  name: 'Visitas',
  iconsrc: 'Icono Visitantes 2.png'
}

export const feedRoute = {
  name: 'Muro de noticias',
  icon: faBullhorn,
  to: '/dashboard/feed'
}

export const parkingRoute = {
  name: 'Parqueo',
  iconsrc: 'Icono Parqueaderos 2.png',
  to: '/dashboard/parking'
}

export const complainRoute = {
  name: 'Sugerencias',
  iconsrc: 'Icono Centro de quejas 2.png',
  to: '/dashboard/complaints'
}

export const commonAreaRoute = { to: '/dashboard/areas', name: 'Areas comunes', iconsrc: 'Icono Areas Comunes 2.png' }

const safetyRoutes = [
 /*  homeRoutes, */
  visitorRoute,
  // feedRoute,
  parkingRoute,
  commonAreaRoute
]

export default safetyRoutes
